// Floating action bar for bulk add-to-theme / remove-from-theme on selected rows.

import {
    Button,
    Typography,
} from "@material-tailwind/react";
import AddToThemeDialog from "../dialog/add-to-theme";
import RemoveFromThemeDialog from "../dialog/remove-from-theme";

export default function SelectedRowsBar({
    selectedCount,
    showAddToThemeDialog,
    showRemoveFromThemeDialog,
    onOpenAddToTheme,
    onOpenRemoveFromTheme,
    onCloseAddToTheme,
    onCloseRemoveFromTheme,
    themes,
    responses,
    onAddToTheme,
    onRemoveFromTheme,
    surveyId,
    themesDataMutate,
    customResponsesFilterMutate,
    handleEditThemeName,
}) {
    if (selectedCount < 1) return null;

    return (
        <div className="flex justify-center items-center border-t py-4 mt-6">
            <Typography as="span" className="text-black mr-2">
                {selectedCount} response{selectedCount !== 1 ? "s" : ""} selected
            </Typography>
            <div className="flex items-center gap-3">
                <AddToThemeDialog
                    open={showAddToThemeDialog}
                    onClose={onCloseAddToTheme}
                    themes={themes}
                    responses={responses}
                    onAddToTheme={onAddToTheme}
                    surveyId={surveyId}
                    themesDataMutate={themesDataMutate}
                    customResponsesFilterMutate={customResponsesFilterMutate}
                    handleEditThemeName={handleEditThemeName}
                />
                <RemoveFromThemeDialog
                    open={showRemoveFromThemeDialog}
                    onClose={onCloseRemoveFromTheme}
                    themes={themes}
                    responses={responses}
                    onRemoveFromTheme={onRemoveFromTheme}
                />
                <Button
                    onClick={onOpenAddToTheme}
                    className="btn btn--primary"
                >
                    Add to Theme
                </Button>
                <Button
                    onClick={onOpenRemoveFromTheme}
                    className="btn btn--primary"
                >
                    Remove from Theme
                </Button>
            </div>
        </div>
    );
}
